export default __webpack_public_path__ + "static/media/SubaruBG.88ce5ef5.png";